// services/api.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const healthCheckApi = createApi({
    reducerPath: 'healthCheckApi',
    baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
    endpoints: (builder) => ({
        healthCheck: builder.query<any, void>({
            query: () => 'health-check',
        }),
    }),
});

export const { useLazyHealthCheckQuery } = healthCheckApi;
